import styled from "@emotion/styled";

export const LogoContainer = styled.span<{ $imgHeight: string }>`
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.navbar.colors.text};
  padding: 0 1rem;

  img {
    filter: ${(p) =>
      p.theme.name === "dark"
        ? "invert(1) brightness(2) contrast(1000%);"
        : "none"};
    height: ${(p) => p.$imgHeight};
  }

  a {
    display: inline-flex;
    align-items: center;
    color: ${(p) => p.theme.navbar.colors.text};
    font-size: ${(p) => p.theme.text.fontSizes.xl};
    line-height: 100%;
  }

  &[aria-disabled="true"] {
    opacity: 0.5;
    pointer-events: none;
  }
`;
